import { render, staticRenderFns } from "./PayRoc.vue?vue&type=template&id=013af638&"
import script from "./PayRoc.vue?vue&type=script&lang=js&"
export * from "./PayRoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports